import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TextField } from '@sitecore-jss/sitecore-jss-angular';
import { ModalComponent, ModalBodyDirective } from '@legacy/common-ui-shared';
import { TrackImpressionDirective } from '@analytics/events';
import { RichTextWrapperComponent } from '@legacy/common-ui-utility-components';
import { AutomationIdDirective } from '@innogy/utils-automation-id';

@Component({
  selector: 'wl-error-modal-placeholder',
  templateUrl: './generic-error-modal.component.html',
  styleUrls: [],
  standalone: true,
  imports: [
    ModalComponent,
    TrackImpressionDirective,
    ModalBodyDirective,
    RichTextWrapperComponent,
    AutomationIdDirective,
  ],
})
export class GenericErrorModalComponent {
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() public modalTitle?: TextField;

  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() public modalMessage?: TextField;

  constructor(private readonly modal: NgbActiveModal) {}

  dismissModal() {
    this.modal.dismiss('dismiss');
  }
}
